module.exports = __webpack_public_path__ + "static/media/rectangle.a6f1f3d8.svg";